



















import { Component, Prop, Vue } from 'vue-property-decorator';
import EmploymentElement from '@/components/employment/EmploymentElement.vue';
import Spinner from '@/components/Spinner.vue';
import { LOAD_STATE } from '@/status';

@Component({
  components: {
    EmploymentElement,
    Spinner,
  },
})
export default class EmploymentList extends Vue {
  public mounted() {
    this.$store.dispatch('fetchEmployment');
  }

  get noData() {
    return (
      this.$store.state.status.expierence === LOAD_STATE.EMPTY ||
      this.$store.state.status.expierence === LOAD_STATE.LOADING
    );
  }

  get isLoading() {
    return this.$store.state.status.expierence === LOAD_STATE.LOADING;
  }

  get history() {
    return this.$store.state.expierence;
  }
}
